// extracted by mini-css-extract-plugin
export default {"errorFallback":"ErrorBoundary_error-fallback__xTY6S"};